import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { camera, bookmarkTabs } from '../../../../../../../../../../shared/assets/emojis';
import { longDateTime } from '../../../../../../../../../../shared/utils/formattedDates';
import { validatePhoneNumber } from '../../../../../../../../../../shared/utils/validators';

import SlotSelection from './components/SlotSelection';
import ContactForm from './components/ContactForm';

import { Emoji, Button } from 'hosman-material';

import { createPhotoMeeting, updateErrors, updateStep } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const PhotoMeeting = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { newPhotoMeetingParams: { formValues, isSubmitting, globalError }, photoPacks: { lightshop_payment_form_url, lightshop_pack_max }} = useSelector((state) => state.sellerPhotoMeetings);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (lightshop_payment_form_url) return handleValidationForPayement();
    
    dispatch(createPhotoMeeting({ saleId: sale.id, params: { ...formValues, contact_name: `${formValues.contact_name} ${formValues.last_name}`} }));
  }

  const handleValidationForPayement = async () => {
    const errors = {}

    if (!formValues.contact_name)   errors.contact_name = ['est requis']
    if (!formValues.access_details) errors.access_details = ['est requis']
    
    const isPhoneValid = await validatePhoneNumber(formValues.contact_phone_country_code, formValues.contact_phone_number)
    if (!isPhoneValid.valid) errors.contact_phone_number = ['*Numéro de téléphone non valide']
      
    const isValid = Object.keys(errors).length === 0

    isValid ? dispatch(updateStep('Paiement')) : dispatch(updateErrors(errors))
  }
  
  return (
    <div className='flex flex-col gap-8'>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col align-items gap-4 mx-auto'>
          <div className='flex justify-center items-center gap-3'>
            <Emoji emojiSrc={camera} width='w-12' />
            {lightshop_pack_max && <Emoji emojiSrc={bookmarkTabs} width='w-10' />}
          </div>
          {!lightshop_pack_max && <p className='h2 text-center'>Réservez votre reportage photo</p>}
          {lightshop_pack_max && <p className='h2 text-center'>Choisissez un créneau pour votre prestation reportage photo + diagnostics</p>}
        </div>

        <p>Un photographe professionnel se rendra directement chez vous à l'horaire choisi. La durée varie entre 45min et 1h30, selon la surface de votre bien.</p>
      </div>

      <SlotSelection />

      <ContactForm />

      <div className='flex flex-col gap-3 text-center'>
        <p className='font-semibold h-6'>{formValues.start_date && longDateTime({ date: formValues.start_date, capitalized: true })}</p>
        {globalError && <p className='text-ih-red text-sm'>{globalError}</p>}
        <Button label='Réserver ce créneau' onClick={handleSubmit} isLoading={isSubmitting} disabled={!formValues.start_date} />
      </div>
    </div>
  )
}

export default PhotoMeeting;
